import React from "react";
import type { TNavItemConfig } from "@/types";
import { NavLink } from "react-router-dom";
import NavIcon from "@/components/navigation/navIcon";
import { Button, Nav } from "react-bootstrap";
import { useTranslation } from "react-i18next";

interface IMobileBottomNavItemProps {
  item: TNavItemConfig;
  path?: string;
  onAction?: () => void;
  showDot?: boolean;
  disabled?: boolean;
}

const MobileBottomNavItem: React.FC<IMobileBottomNavItemProps> = ({
  item,
  path,
  onAction,
  showDot = false,
  disabled = false,
}) => {
  const { t } = useTranslation();

  const tileBaseClass =
    "d-flex flex-column align-items-center justify-content-center rounded-3 p-2 nav-link-active";
  const iconWrapperClass = "position-relative lh-1";

  const content = (isActive?: boolean) => (
    <div
      className={`${tileBaseClass} ${isActive ? "bg-additional-violet text-primary" : ""}`}
    >
      <div className={iconWrapperClass}>
        <NavIcon iconKey={item.iconKey} variant="mobile" />
        {showDot && (
          <span className="position-absolute top-0 start-100 translate-middle p-1 bg-primary border border-white rounded-circle">
            <span className="visually-hidden">has items</span>
          </span>
        )}
      </div>
      <span className="fs-12 mt-1">{t(item.label)}</span>
    </div>
  );

  if (item.type === "action") {
    return (
      <Button
        variant="link"
        className="p-0 d-flex text-decoration-none"
        onClick={onAction}
        disabled={disabled}
      >
        <div className={disabled ? "text-grey" : "text-grey-text"}>
          {content(false)}
        </div>
      </Button>
    );
  }

  if (!path || disabled) {
    return (
      <Button
        variant="link"
        className="p-0 d-flex text-decoration-none"
        disabled
      >
        <div className="text-grey">{content(false)}</div>
      </Button>
    );
  }

  return (
    <Nav.Item>
      <NavLink
        to={path}
        end={item.key === "menu"}
        className={({ isActive }) =>
          `nav-link p-0 d-flex text-decoration-none ${isActive ? "text-primary" : "grey-text"}`
        }
      >
        {({ isActive }: { isActive: boolean }) => content(isActive)}
      </NavLink>
    </Nav.Item>
  );
};

export default MobileBottomNavItem;
